/*
  Что в значении файла новое по сравнению с портфелем - для жёлтой подсветки в
  строке расхождения (макет А владельца, 01.10.2026).

  Сравниваются слова, а не буквы: «кв. 15» против «кв. 5» подсвечивает «15», а
  полный адрес против «Дом 23, кв. 81» - область, город и улицу. Регистр, «ё» и
  знаки препинания отличием не считаются - так же сравнивает сервер. Подсветка
  только помогает глазу: что расхождение по существу, решает сервер, а не она.
*/

const plain = (word) => word.toLowerCase().replace(/ё/g, 'е').replace(/[^0-9a-zа-я]/g, '')

export default function changedParts(before, after) {
  const known = new Set(before.split(/\s+/).map(plain))
  const parts = []
  for (const token of after.split(/(\s+)/)) {
    if (!token) continue
    const isSpace = /^\s+$/.test(token)
    const word = plain(token)
    const changed = !isSpace && word !== '' && !known.has(word)
    const last = parts[parts.length - 1]
    // Пробел между двумя новыми словами - часть одной подсветки, а не разрыв.
    if (last && (last.changed === changed || (isSpace && last.changed))) {
      last.text += token
    } else {
      parts.push({ text: token, changed })
    }
  }
  return trimmed(parts)
}

// Пробел в конце подсвеченного куска уходит из подсветки в обычный текст.
function trimmed(parts) {
  return parts.flatMap((part) => {
    const match = part.changed ? part.text.match(/^(.*?)(\s+)$/s) : null
    return match ? [{ text: match[1], changed: true }, { text: match[2], changed: false }] : [part]
  })
}
